import * as ExcelJS from 'exceljs';
import moment from 'moment';

export const styleHeader = (worksheet: ExcelJS.Worksheet, rowIndex: number, color: string = 'F6991D', isSubHeader: boolean = false) => {
    worksheet.getRow(rowIndex).alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true,
    };
    worksheet.getRow(rowIndex).eachCell(function (cell) {
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: color }
        };
    });
    worksheet.getRow(rowIndex).font = {
        name: 'Arial',
        size: isSubHeader ? 8 : 10,  // Ukuran font lebih kecil untuk subHeader
        bold: !isSubHeader,  // Bold hanya untuk header utama
    };
};

export const styleHeaderDateRange = (worksheet: ExcelJS.Worksheet, dateRangeRow: ExcelJS.Row) => {
    worksheet.mergeCells(`A${dateRangeRow.number}:B${dateRangeRow.number}`);
    worksheet.getRow(dateRangeRow.number).height = 35;
    dateRangeRow.getCell(1).alignment = {
        vertical: 'middle',
        horizontal: 'left',
    };
    dateRangeRow.getCell(1).font = {
        name: 'Arial',
        size: 14,
        bold: true,
    };
}

export const downloadExcel = async (workbook: ExcelJS.Workbook, nameFile: string, dateRange?: [Date, Date] | null) => {
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${nameFile}${dateRange ? `(${moment(dateRange[0]).format('DD MMM YYYY')} - ${moment(dateRange[1]).format('DD MMM YYYY')})` : ''}.xlsx`;
    a.click();
    window.URL.revokeObjectURL(url);
};

export const styleColumnWidth = (worksheet: ExcelJS.Worksheet, defaultWidth: number = 30, dataCustomWidth: number[] = []) => {
    worksheet.columns.forEach((column, index) => {
        if (dataCustomWidth[index]) {
            column.width = dataCustomWidth[index];
        } else {
            column.width = defaultWidth;
        }
    });
}


export const addTotalRow = (worksheet: ExcelJS.Worksheet, data: Array<{ value: any, index: number }>, totalColumns: number) => {
    const rowData = new Array(totalColumns).fill('');

    data.forEach(item => {
        rowData[item.index] = item.value;
    });

    const totalRow = worksheet.addRow(rowData);
    totalRow.font = {
        size: 10,
        bold: true
    };

    totalRow.eachCell((cell, colNumber) => {
        if (typeof cell.value === 'number') {
            cell.numFmt = '#,##0;[Red]-#,##0';
        }
    });

    return totalRow;
};